import { JSX, useEffect } from 'react'

import { redirectLocation } from '../../services/urls'
import Alert, { AlertColor } from './Alert'

type AlertWithRedirectProps = {
  color: AlertColor
  alertMessage: string
  redirectMessage: string
  urlToRedirect: string
}

export default function AlertWithRedirect({
  color,
  alertMessage,
  redirectMessage,
  urlToRedirect,
}: AlertWithRedirectProps): JSX.Element {
  useEffect(() => {
    const timeout = setTimeout(() => redirectLocation(urlToRedirect), 8000)

    return () => clearTimeout(timeout)
  }, [urlToRedirect])

  return (
    <div className="relative w-full">
      <Alert color={color}>{alertMessage}</Alert>
      <p className="pt-2">Vous allez être redirigé vers {redirectMessage} dans un instant.</p>
    </div>
  )
}
